export enum CTAThemes {
  WRITTEN_CONTACT = 'Kontakt schriftlich', // Written contact
  PERSONAL_CONTACT = 'Kontakt persöhnlich', // Personal contact
  ONLINE_COMPLETION = 'Online-Abschluss', // Online completion
  ONLINE_OFFER = 'Online-Angebot', // Online offer
  DAMAGE = 'Schaden', // Damage
  TECHNICAL = 'Technik', // Technical
  FEEDBACK = 'Feedback', // Feedback
}
